import React from "react";
import SEO from "../../components/seo";

const pageHeading = {
	fontFamily: "var(--heading-font)",
	fontWeight: 800,
	fontSize: 32,
	lineHeight: 1.2,
	color: "var(--text)",
	margin: "0 0 32px",
};

const sectionHeading = {
	fontFamily: "var(--heading-font)",
	fontWeight: 700,
	fontSize: 22,
	lineHeight: 1.3,
	color: "var(--text)",
	margin: "0 0 20px",
	borderLeft: "4px solid var(--primary)",
	paddingLeft: 16,
};

const bodyText = {
	fontFamily: "var(--body-font)",
	fontSize: 15.5,
	lineHeight: 1.75,
	color: "var(--text-muted)",
	margin: "0 0 40px",
};

const FeesAndCharges = () => {
	return (
		<div>
			<SEO
				title="Fees & Charges"
				keywords={[
					`Fees`,
					`Charges`,
					`Gastroenterologist`,
					`Hepatologist`,
					`Dr Frank Brennan`,
					`Dr Spiro Raftopoulos`,
					`Dr Ian Yusoff`,
					`Dr Dev Segarajasingam`,
					`Dr Sam Rao`,
					`Dr Duy Pham`,
					`Dr Claire Gordon`,
				]}
				description="Fees and charges at Advanced GI"
			/>

			<h1 style={pageHeading}>Fees and Charges</h1>

			<h2 style={sectionHeading}>Private Health Insurance &amp; Inpatient Procedures</h2>
			<p style={bodyText}>
				Our practice actively supports the use of private health insurance, and nearly all inpatient procedures
				are billed directly to your insurer. Most anaesthetists currently retained by this practice are no-gap
				providers; however, some anaesthetists may charge a gap fee. Anaesthetists set their own fees
				independently, and this is outside our control — where a gap applies, it will be disclosed to you
				directly by the anaesthetist. Separately, where a procedure itself is expected to be long or complex —
				for example, when it is being performed as an alternative to surgery — a gap fee for the procedure may
				apply. In this case, well discuss the gap and the reasons for it with you before the procedure goes
				ahead.
			</p>

			<h2 style={sectionHeading}>Consultation Fees</h2>
			<p style={bodyText}>
				The gap fee for consultations typically ranges from $50 to $350, depending on the length and complexity
				of the appointment. Consultations for a second opinion, or referrals from other specialists requiring
				more detailed assessment, usually take longer and may involve a higher gap fee. Once we receive your
				referral, the treating specialist will review it and we can provide an estimate of any gap fee that may
				apply. EFTPOS is available, and payment on the day of consultation is appreciated. A valid referral is
				your responsibility and is required to claim a Medicare rebate.
			</p>

			<h2 style={sectionHeading}>Overseas &amp; Uninsured Patients</h2>
			<p style={{ ...bodyText, marginBottom: 0 }}>
				For patients with overseas health insurance, or uninsured patients seeking private care, fees are
				charged at the rate recommended by the Australian Medical Association (AMA).
			</p>
		</div>
	);
};

export default FeesAndCharges;
